import { toastErrorMenssage } from "#/contextProver/ContextProverServices";
import { Errors, request } from "#/utils/request";

export interface IGetVendasListaProposta {
  codigoComissionado: string;
  documento: string;
}

export interface IGetVendasListaPropostaData {
  data: DataListaProposta[];
  errors: Errors;
}

export interface DataListaProposta {
  cdGrupo: string;
  cdCota: number;
  versao: number;
  idDocumento: number;
  idTipoDocumento: number;
  idEmpresa: number;
  idPontoVenda: number;
  idProduto: number;
  idUnidadeNegocio: number;
  contratoAssinado: string;
  boletoGerado: string;
  boletoPago: string;
  dataPagamento: string;
  situacaoGrupo: string;
  dataInauguracao: string;
  numeroAssembleia: number;
  dataPrimeiraAssembleia: string;
  dataVencimentoPrimeiraAssembleia: string;
  dataAssembleia: string;
  dataLimiteOfertaLance: string;
  diaVencimento: number;
  dataAlocacaoProposta: string;
  dataCancelamentoProposta: string;
  dataVencimetoBoletoAdesao: string;
  contratoGerado: string;
  assinaturaVencida: string;
}

export const getVendasListaProposta = async ({
  codigoComissionado,
  documento,
}: IGetVendasListaProposta) => {
  const { data } = await request.get<IGetVendasListaPropostaData>(
    `/vendas/lista-propostas?codigoComissionado=${codigoComissionado}&documento=${documento}`
  );
  if (data) {
    return data;
  } else {
    toastErrorMenssage();
    throw new Error("Não possui dados. Retorno null.");
  }
};
